import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { apiBaseUrl, baseUrl } from "../config";
import VariantList from "../components/VariantList";
import ProductsMapList from "../components/ProductsMapList";
import { useDispatch, useSelector } from "react-redux";
import CommonLayout from "../layout/CommonLayout";
import { getModalState } from "../reducer/manageModalStateSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { getList } from "../reducer/productListSlice";
import ShareButton from "../components/modal/WebShareBtn";
import { getSizeChart } from "../reducer/commonValuesSlice";
import { getDomainInfo, isVideo } from "../utils/utils";
import ImgOrVideo from "../components/ImgOrVideo";
import sizechart from "../assets/images/no-image-available.jpg";
import CommonModal from "../components/modal/CommonModal";
import HtmlStringRenderer from "../components/html/HtmlStringRenderer";
import { getCartInfo } from "../reducer/userCartSlice";
import _ from "lodash";
import GoogleLogo from "../assets/images/icons/Google_2015_logo.svg";
import { CiCircleMinus } from "react-icons/ci";
import { CiCirclePlus } from "react-icons/ci";
import { BiCopy } from "react-icons/bi";
import DiscountList from "../components/DiscountList/DiscountList";
import Delivery from "../components/Delivery/Delivery";
import Description from "../components/Description/Description";
import ViewMoreContent from "../components/ViewMoreContent/ViewMoreContent";
import FourGrid from "../components/FourGrid/FourGrid";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import CommonDrawer from "../components/drawer/CommonDrawer";
import ZoomImg from "../assets/images/zoom-icon.png";
import axios from "axios";
import Loader from "../components/loader/Loader";
import { useUser } from "../context/userContext";
import Footer from "../components/Footer/Footer";
import ReviewsAccordion from "../components/ReviewsAccordion/ReviewsAccordion";
import ReviewModal from "../components/modal/ReviewModal";
import { toast } from 'react-toastify';
import { useCallback } from "react";
import { FaChevronLeft, FaChevronRight, FaEye, FaRegStar, FaStar } from "react-icons/fa";
import RandomNumber from "../components/RandomNumber/RandomNumber";

let TOAST_ID = "no-inventory-toast";
function ProductDetails({ setCartLength }) {
  const [loading, setLoading] = useState(false);
  const [productDetails, setProductDetails] = useState();
  const [productAttributes, setProductAttributes] = useState();
  const [firstMatchingVariant, setFirstMatchingVariant] = useState();
  const [selectedVariantValues, setSelectedVariantValues] = useState({});
  const [variantlength, setvariantlength] = useState(0);
  const [dynamicIds, setDynamicIds] = useState({});
  const [indexOne, setIndexone] = useState(null);
  const [indexTwo, setIndextwo] = useState(null);
  const [isInCart, setIsInCart] = useState();
  const [returnpolicydata, setreturnpolicydata] = useState([]);
  const [returnpolicy, setreturnpolicy] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [currentProductId, setCurrentProductId] = useState();
  const isCOD = useSelector((state) => state.fetchUser?.user?.isCOD);
  const { userId, productName } = useParams();
  const { isPredefinedDomain, uid } = getDomainInfo(userId);
  const { userData, fetchUserData } = useUser();
  const [reviews, setReviews] = useState([]);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [hasPurchasedProduct, setHasPurchasedProduct] = useState(false);

  useEffect(() => {
    if (uid) {
      fetchUserData(uid);
    } else {
      console.error("UID is undefined, skipping fetchUserData.");
    }
  }, [uid]);
  const userid = userData?.id;
  console.log("id from product details", userid);
  // const userid = useSelector((state) => state.fetchUser?.user?.id);

  let productId;

  if (location?.state && location.state.productId) {
    productId = location.state.productId;
  }

  const customSort = useSelector((state) => state.fetchUser?.user?.customSort);
  const pId = useSelector((state) => state.productslst?.particularId);
  const productList = useSelector((store) => store.productslst?.products);
  const [constItemDetails, setConstItemDetails] = useState({
    title: "",
    des: "",
    img: [],
  });
  const [ProductVariantLength, setProductVariantLength] = useState();
  const [selectedVariantStock, setSelectedVariantStock] = useState(null);
  const cartContext = localStorage.getItem("cartContext");
  let token = localStorage.getItem("token");
  const [isVarient, setisvarient] = useState(false);

  const cartItems = useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];
  const customerId = localStorage.getItem("customerId");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [count, setCount] = useState(1);
  const [productTag, setProductTag] = useState("");
  const [categories, setCategories] = useState([]);
  const [adding, setAdding] = useState(false)
  useEffect(() => {
    const productVariants = productDetails?.additionalInfo?.productVariants;
    const firstProductVariants = productVariants?.[0]?.variants || [];
    const uniqueVariants = firstProductVariants.filter(
      (variant, index, self) =>
        index === self.findIndex((v) => v.value._id === variant.value._id)
    );
    setvariantlength(uniqueVariants.length);
  }, [productDetails, indexOne, indexTwo, productId, productName]);

  const fetchProductDetails = async () => {
    console.log("Fetching product details...");
    setLoading(true);
    try {
      let data;
      if (productId) {
        const response = await fetch(
          `${apiBaseUrl}user/get-seller-product-details/${userid}/${productId}`
        );
        data = await response.json();
      } else {
        const response = await axios.get(
          `${apiBaseUrl}user/get-product-details/${userid}/${productName}`
        );
        data = response.data;
      }

      setLoading(false);
      setProductDetails(data?.product);
      saveToRecentlyViewed(data?.product);
      setCurrentProductId(data?.product?.id);
      dispatch(getSizeChart(data?.product?.sizeChart));
      setProductAttributes(data?.product?.additionalInfo?.attributes);
      setProductVariantLength(data?.product?.additionalInfo?.productVariants);
      setProductTag(data?.product?.tags?.[0]);
      if (data?.product?.additionalInfo?.productVariants.length === 0) {
        setisvarient(false);
      } else {
        setisvarient(true);
      }

    } catch (error) {
      setLoading(false);
      console.error("Error fetching product details:", error);
    }
  };
  useEffect(() => {
    if (productId && userid !== undefined) {
      fetchProductDetails();
    } else if (productName && userid !== undefined) {
      fetchProductDetails();
    }
  }, [productId, userid, dispatch, productName]);

  const fetchProductList = async () => {
    try {
      if (!currentProductId) return;
      const response = await fetch(
        `${apiBaseUrl}user/get-related-products/${currentProductId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customSort: customSort,
          }),
        }
      );
      const data = await response.json();
      dispatch(getList(data?.products));
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  };

  const fetchreturnPolicy = async () => {
    try {
      const response = await fetch(`${apiBaseUrl}rPolicy/getReturnPolicy`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: userid,
        }),
      });
      const data = await response.json();
      setreturnpolicydata(data);
      setreturnpolicy(data?.data?.description);
    } catch (error) {
      console.error("Error fetching cancellation policy:", error);
    }
  };

  // Function to fetch the tag for a specific product
  useEffect(() => {
    fetchProductList();
    fetchreturnPolicy();
  }, [currentProductId]);

  useEffect(() => {
    if (productDetails) {
      setConstItemDetails({
        title: productDetails?.title,
        des: productDetails?.description,
        img: productDetails?.images,
      });
    }
  }, [productDetails]);

  const updateState = () => {
    const entries = Object.entries(selectedVariantValues);

    if (entries.length === 0) {
      setIndexone(null)
      setIndextwo(null)
    }

    const newDynamicIds = (() => {
      // If only one value is selected
      if (entries.length === 1) {
        const [onlyKey, onlyValue] = entries[0];
        return Object.keys(dynamicIds).reduce((acc, key) => {
          acc[key] = key === onlyKey ? onlyValue?.id : null;
          setIndextwo(null)

          return acc;
        }, {});

      }

      // If multiple values are selected
      return entries.reduce((acc, [key, value]) => {
        acc[key] = value?.id;
        return acc;
      }, {});
    })();

    setDynamicIds((prev) => {
      const isSame = Object.keys(newDynamicIds).every(
        (key) => prev[key] === newDynamicIds[key]
      );
      return isSame ? prev : newDynamicIds;
    });
  };

  useEffect(() => {
    updateState();
  }, [selectedVariantValues, variantlength]);

  useEffect(() => {
    if (dynamicIds[Object.keys(dynamicIds)[0]]) {
      setIndexone(dynamicIds[Object.keys(dynamicIds)[0]]);
    }
    if (dynamicIds[Object.keys(dynamicIds)[1]]) {
      setIndextwo(dynamicIds[Object.keys(dynamicIds)[1]]);
    }
  }, [dynamicIds]);

  const onVariantSelect = (selectedValues) => {
    setSelectedVariantValues(selectedValues);
    if (productDetails?.additionalInfo?.productVariants) {
      const matchingVariant = productDetails.additionalInfo.productVariants.find(
        (variant) =>
          variant.variants.every(
            (v) => selectedValues[v.title]?.id === v.value._id
          )
      );

      if (matchingVariant) {
        setSelectedVariantStock(matchingVariant.stock);
      }
    }
  };

  useEffect(() => {
    if (!productDetails?.id || !cartItems?.length) return;

    const pid = productDetails.id;

    const variantObject = selectedVariantValues
      ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
        const keyName = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
        acc[keyName] = { title: value };
        return acc;
      }, {})
      : {};

    let matchedItem = null;

    for (const item of cartItems) {
      const itemId = item?.productId || item?.id;

      if (itemId !== pid) continue;

      // Simple product (no variants)
      if (variantlength === 0) {
        matchedItem = item;
        break;
      }

      // Variant match
      if (item.variant && Object.keys(item.variant).length > 0) {
        const varintid1 = item.variant.firstVariant?.title?.id;
        const objectid1 = variantObject.firstVariant?.title?.id;

        const varintid2 = item.variant.secondVariant?.title?.id;
        const objectid2 = variantObject.secondVariant?.title?.id;
        let isMatch = false;
        if(varintid2 && objectid2){
          isMatch = _.isEqual(varintid1, objectid1) && _.isEqual(varintid2, objectid2);
        }
        else{
          isMatch = _.isEqual(varintid1, objectid1);
        }
        if (isMatch) {
          matchedItem = item;
          break;
        }
      }
    }

    if (matchedItem) {
      setIsInCart(true);
      setCount(matchedItem.quantity || 1);
    } else {
      setIsInCart(false);
      setCount(1);
    }
  }, [
    productDetails?.id,
    cartItems,
    selectedVariantValues,
    indexOne,
    indexTwo,
    variantlength
  ]);

  const isOutOfStock = () => {
    if (isVarient) {
      return selectedVariantStock <= 0;
    } else {
      return productDetails?.stock <= 0;
    }
  };

  const isIncrementDisabled = () => {
    if (isVarient) {
      return count >= selectedVariantStock;
    } else {
      return count >= productDetails?.stock;
    }
  };


  const buyItNow = () => {
    handleAddToCart(true);
  };

  const handleAddToCart = async (buyItNow) => {
    if (isOutOfStock()) {
      console.log("Product is out of stock, cannot add to cart.");
      return;
    }
    if (adding) return;
    setAdding(true);

    try {
      const productId = productDetails?.id;
      const params = new URLSearchParams({ productId });
      if (indexOne) params.append("variant1Id", indexOne);
      if (indexTwo) params.append("variant2Id", indexTwo);

      const res = await fetch(`${apiBaseUrl}product/get-live-stock?${params.toString()}`);
      const data = await res.json();
      const latestStock = data.stock || 0;
      const latestPrice = data.price || 0;
      const latestMrp = data.mrp || 0;

      // 🟡 Show toast if price or MRP changed
      let currentPrice, currentMrp;
      if (isVarient) {
        currentPrice = selectedVariantValues?.price;
        currentMrp = selectedVariantValues?.mrp;
      } else {
        currentPrice = productDetails?.price;
        currentMrp = productDetails?.mrp;
      }

      const hasPriceChanged = latestPrice !== currentPrice || latestMrp !== currentMrp;
      if (hasPriceChanged) {
        toast.info(`Price updated by the seller to ₹${latestPrice || latestMrp}`, {
          position: "top-center",
          autoClose: 2500,
        });
      }

      // 🟡 Update UI
      if (isVarient) {
        // For variant products, update selectedVariant to trigger re-render
        // const matchingVariant = productDetails?.additionalInfo?.productVariants?.find(
        //   (variant) =>
        //     variant.variants.every(
        //       (v) => selectedVariantValues[v.title]?.id === v.value._id
        //     )
        // );
        // if (matchingVariant) {
        //   matchingVariant.price = latestPrice;
        //   matchingVariant.mrp = latestMrp;
        //   setSelectedVariantValues({ ...matchingVariant });
        // }

        setSelectedVariantValues((prev) => ({
          ...prev,
          price: latestPrice,
          mrp: latestMrp
        }))
        console.log(selectedVariantValues.price, "MatchingPrice")
        console.log(selectedVariantValues, "selectedVarinatValues--->")

      } else {
        setProductDetails((prev) => ({
          ...prev,
          price: latestPrice,
          mrp: latestMrp,
        }));
      }

      // 🟡 Continue Add to Cart Logic
      const variantImage = getFilteredImages();
      const isVideoProduct = variantImage[0] && isVideo(variantImage[0]);
      const productImage = isVideoProduct ? sizechart : variantImage[0];

      const variant = selectedVariantValues
        ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
          const variantKey = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
          acc[variantKey] = { title: value };
          return acc;
        }, {})
        : null;

      const productData = {
        id: productDetails?.id,
        title: productDetails?.title,
        price: latestPrice === 0 ? latestMrp : latestPrice,
        image:
          isVarient && selectedVariantValues?.images?.length > 0
            ? selectedVariantValues?.images[0]
            : productImage,
        quantity: count,
        storeid: userid,
        variant: variant,
        stock: latestStock,
      };

      const findMatchingCartItem = (cartItems, productData) => {
        return cartItems.find((item) => {
          const itemId = item.productId || item.id;
          if (itemId !== productData.id) return false;

          if (productData.variant && Object.keys(productData.variant).length > 0) {
            return (
              item.variant &&
              Object.keys(item.variant).length > 0 &&
              _.isEqual(item.variant, productData.variant)
            );
          }

          return !item.variant || Object.keys(item.variant).length === 0;
        });
      };

      // const productExists = cartItems.some((item) => {
      //   if (item.id === productData.id) {
      //     if (
      //       productData.variant &&
      //       Object.keys(productData.variant).length !== 0
      //     ) {
      //       if (
      //         item.variant &&
      //         Object.keys(item.variant).length !== 0 &&
      //         _.isEqual(item.variant, productData.variant)
      //       ) {
      //         return true;
      //       }
      //     } else {
      //       return true;
      //     }
      //   }
      // });
      const productExists = findMatchingCartItem(cartItems, productData);

      if (productExists) {
        // Update the quantity of the existing item
        const existingItem = cartItems.find(
          (item) =>
            item.id === productData.id &&
            (_.isEqual(item.variant, productData.variant) || !productData.variant)
        );

        if (existingItem) {
          const updatedQuantity = existingItem.quantity + count;
          const productId = existingItem.productId || existingItem.id;

          await updateProductQuantity(updatedQuantity, productId, variant).then(
            (cartItems) => {
              if (cartItems) {
                updateCartLengthAndShowModal(cartItems);

                if (window.fbq && typeof window.fbq === 'function') {
                  const contentIds = [
                    isVarient && selectedVariantValues?.sku_id
                      ? selectedVariantValues.sku_id
                      : productDetails?.skuId
                  ];
                  window.fbq('track', 'AddToCart', {
                    content_ids: contentIds,
                    content_type: 'product',
                  });
                }
              }
            },
            (error) => {
              console.error(
                `Error occurred while updating the item quantity in cart: ${error}`
              );
            }
          );


        }
      } else {
        // Add a new item to the cart
        await addItemToTheCart(productData, count).then(
          (cartItems) => {
            if (cartItems) {
              updateCartLengthAndShowModal(cartItems);

              if (window.fbq && typeof window.fbq === 'function') {
                const contentIds = [
                  isVarient && selectedVariantValues?.sku_id
                    ? selectedVariantValues.sku_id
                    : productDetails?.skuId
                ];
                window.fbq('track', 'AddToCart', {
                  content_ids: contentIds,
                  content_type: 'product',
                });
              }


              // fetchUserCartInfo(userid)

              // setOpen(true);
              if (buyItNow === true) {
                navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
                setTimeout(() => window.location.reload(), 100);
              }
            }
          },
          (error) => {
            console.error(
              `Error occurred while adding item to the cart: ${error}`
            );
          }
        );
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    } finally {
      setAdding(false);
    }
  }



  /**
   * This method is used to update cart length and show success model for add to cart
   * @param updatedCart
   */
  const updateCartLengthAndShowModal = (updatedCart) => {
    const filteredCart = updatedCart.filter((item) => item.storeid === userid);
    setCartLength(filteredCart.length);
    setIsInCart(true);

    // const addCartModal = new window.bootstrap.Modal(
    //   document.getElementById("addCart")
    // );
    // addCartModal.show();

    // const modalElement = document.getElementById("addCart");
    // const handleModalCleanup = () => {
    //   document.body.style.overflow = "";
    //   document.body.style.paddingRight = "";

    //   const backdropElement = document.querySelector(".modal-backdrop");
    //   if (backdropElement) {
    //     backdropElement.remove();
    //   }

    //   modalElement.removeEventListener("hidden.bs.modal", handleModalCleanup);
    // };
    toast.success('Item added to cart successfully')
    // modalElement.addEventListener("hidden.bs.modal", handleModalCleanup);
  };

  /**
   * This method is used to update product quantity
   * @param quantity
   * @param productId
   * @returns {Promise<unknown>}
   */
  const updateProductQuantity = async (quantity, productId, variant) => {
    return new Promise(async (resolve, reject) => {
      try {
        let headers = {
          "Content-Type": "application/json",
        };
        if (token) {
          headers["token"] = token;
        }
        const response = await fetch(
          `${apiBaseUrl}cart/update-item-quantity-in-cart`,
          {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
              storeid: userid,
              id: productId,
              quantity: quantity,
              variant: variant,
              cartContext: cartContext,
              customerId: customerId,
            }),
          }
        );
        const data = await response.json();
        dispatch(getCartInfo(data?.cart));
        resolve(data?.cart?.cartItem);
      } catch (e) {
        console.error("error while updating the quantity of product");
        reject(e);
      }
    });
  };

  /**
   * This method is used to add item to the cart
   * @param item
   * @returns {Promise<unknown>}
   */
  const addItemToTheCart = async (item) => {
    return new Promise(async (resolve, reject) => {
      try {
        let headers = {
          "Content-Type": "application/json",
        };
        if (token) {
          headers["token"] = token;
        }

        const response = await fetch(`${apiBaseUrl}cart/add-item-in-cart`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            id: item?.id,
            image: item?.image,
            price: item?.price,
            quantity: count,
            storeid: item?.storeid,
            title: item?.title,
            variant: item?.variant,
            cartContext: cartContext,
            customerId: customerId,
            stock: item?.stock
          }),
        });
        const data = await response.json();
        if (data?.cartContext) {
          localStorage.setItem("cartContext", data.cartContext);
        }
        dispatch(getCartInfo(data?.cart));
        resolve(data?.cart?.cartItem);
      } catch (e) {
        console.error("error while updating the quantity of product");
        reject(e);
      }
    });
  };

  const handlegoToCart = () => {
    navigate(isPredefinedDomain ? `/${uid}/cart` : "/cart");
    setTimeout(() => window.location.reload(), 100);
  };

  const handleOpenDrawer = (product) => {
    setSelectedProduct(product);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedProduct(null);
  };

  const fetchUserCartInfo = async (storeId, token) => {

    if (!storeId) {
      console.warn("Missing necessary data for cart request.");
      return;
    }
    try {
      const response = await fetch(`${apiBaseUrl}cart/fetch-user-cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token && { token: token }),
        },
        body: JSON.stringify({
          storeid: storeId,
          customerId: customerId,
          cartContext: cartContext,
        }),
      });
      const data = await response.json();

      if (data?.cart) {
        dispatch(getCartInfo(data.cart));
      }
    } catch (e) {
      console.error("Error while fetching user cart information:", e);
    }
  };
  // console.log(userid,'userid')
  useEffect(() => {

    if (userid) {
      fetchUserCartInfo(userid)
    }
  }, [userid])


  const incrementHandler = async () => {
    const productId = productDetails?.id;
    let liveStock = 0;

    if (isVarient) {
      liveStock = await fetchLiveStock(productId, indexOne, indexTwo);
    } else {
      liveStock = await fetchLiveStock(productId);
    }

    if (count >= liveStock) {
      toast.warn("No more inventory", { position: "top-center", autoClose: 2000 });
      return;
    }

    const newCount = count + 1;
    setCount(newCount);

    if (isInCart) {
      const variant =
        selectedVariantValues && Object.entries(selectedVariantValues).length > 0
          ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
            const variantKey = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
            acc[variantKey] = { title: value };
            return acc;
          }, {})
          : null;

      await updateProductQuantity(newCount, productId, variant);



    }
  };

  const decrementHandler = async () => {
    if (count <= 1) return;

    const productId = productDetails?.id;
    let liveStock = 0;

    if (isVarient) {
      liveStock = await fetchLiveStock(productId, indexOne, indexTwo);
    } else {
      liveStock = await fetchLiveStock(productId);
    }

    if (count > liveStock) {
      toast.warn(`Product Sold Out. Only ${liveStock} item${liveStock !== 1 ? 's' : ''} left.`, {
        position: "top-center",
        autoClose: 2000,
      });
      setCount(liveStock);
      if (isInCart) {
        const variant =
          selectedVariantValues && Object.entries(selectedVariantValues).length > 0
            ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
              const variantKey = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
              acc[variantKey] = { title: value };
              return acc;
            }, {})
            : null;

        await updateProductQuantity(liveStock, productId, variant);
      }
      return;
    }

    const newCount = count - 1;
    setCount(newCount);

    if (isInCart) {
      const variant =
        selectedVariantValues && Object.entries(selectedVariantValues).length > 0
          ? Object.entries(selectedVariantValues).reduce((acc, [key, value], index) => {
            const variantKey = index === 0 ? "firstVariant" : index === 1 ? "secondVariant" : `variant${index + 1}`;
            acc[variantKey] = { title: value };
            return acc;
          }, {})
          : null;

      await updateProductQuantity(newCount, productId, variant);
    }
  };

  // const userwala = "665ff5a9886ff31821399166";

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${apiBaseUrl}user/get-seller-categories/${userid}`
      );
      const data = await response.json();
      setCategories(data.categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [userid]);

  const handleCategoryClick = async (categoryTitle) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}user/filter-seller-products-by-category/${userid}`
      );
      if (response.data && response.data.products) {
        // Filter products where category.title matches the selected category title
        const filteredProducts = response.data.products.filter((product) => {
          console.log("Product Category Title:", product.category.title);
          return (
            product.category.title.toLowerCase() === categoryTitle.toLowerCase()
          );
        });
        if (filteredProducts.length > 0) {
          navigate(`/${userId}/category/${categoryTitle}`, {
            state: { products: filteredProducts, categoryTitle },
          });
        } else {
          console.error(
            "No matching products found for the selected category."
          );
        }
      } else {
        console.error("No products found for the selected category.");
      }
    } catch (error) {
      console.error("Error fetching products by category:", error);
    }
  };

  const getFilteredImages = () => {
    if (
      !productDetails?.additionalInfo?.productVariants ||
      !selectedVariantValues
    ) {
      return constItemDetails?.img || []; // Default images if no variant is selected
    }

    // Find the matching variant combination
    const matchingVariant = productDetails.additionalInfo.productVariants.find(
      (variant) =>
        variant.variants.every(
          (v) => selectedVariantValues[v.title]?.id === v.value._id
        )
    );

    // Return the images of the matching variant or default images
    return matchingVariant?.images || constItemDetails?.img || [];
  };

  useEffect(() => {
    if (productDetails) {
      setConstItemDetails({
        title: productDetails?.title,
        des: productDetails?.description,
        img: productDetails?.images,
      });

      // Initialize stock state
      if (productDetails?.additionalInfo?.productVariants?.length === 0) {
        // Non-variant product
        setSelectedVariantStock(productDetails.stock);
      }
    }
  }, [productDetails]);

  useEffect(() => {
    if (!productDetails) return;

    let retries = 10;

    const interval = setInterval(() => {
      if (window.fbq && typeof window.fbq === 'function') {
        console.log("✅ ViewContent fired:", productDetails);

        window.fbq('track', 'ViewContent', {
          content_name: productDetails.title,
          content_ids: [
            isVarient && selectedVariantValues?.sku_id
              ? selectedVariantValues.sku_id
              : productDetails?.skuId
          ],
          content_type: 'product',
          value: productDetails.price,
          currency: 'INR'
        });

        clearInterval(interval);
      } else {
        console.log(`⏳ Waiting for fbq... retries left: ${retries}`);
        retries--;
        if (retries <= 0) {
          console.warn("❌ fbq not ready, ViewContent NOT fired.");
          clearInterval(interval);
        }
      }
    }, 300);

    return () => clearInterval(interval);

  }, [productDetails]);


  const handleShare = async () => {
    const shareUrl = window.location.href
    const shareData = {
      title: productDetails?.title,
      text: productDetails?.description || "Check out this product!",
      url: shareUrl,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        console.log("Product shared successfully");
      } else {
        await navigator.clipboard.writeText(shareUrl);
        alert("Link copied to clipboard!");
      }
    } catch (error) {
      console.error("Error sharing product:", error);
    }
  };

  useEffect(() => {
    const checkPurchaseStatus = async () => {
      if (token && customerId && currentProductId) {
        const config = token ? { headers: { token: token } } : {};
        try {
          const response = await axios.get(`${apiBaseUrl}customer/check-purchase/${currentProductId}`, config);
          setHasPurchasedProduct(response.data.hasPurchased);
        } catch (error) {
          console.log("Error checking purchase status:", error);
          setHasPurchasedProduct(false); // Assume false on error
        }
      } else {
        setHasPurchasedProduct(false);
      }
    };

    checkPurchaseStatus();
  }, [currentProductId, customerId, token]);


  const handleOpenReviewModal = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.info("Please log in to rate this product.");
      // optionally we can redirect or show login prompt
      // navigate('/login', { state: { from: location } });
      return;
    }
    setIsReviewModalOpen(true);
  };

  const handleCloseReviewModal = () => {
    setIsReviewModalOpen(false);
  };

  const handleReviewSubmitSuccess = () => {
    setIsReviewModalOpen(false);
    fetchReviews(); //refetch revviews on successful review 
  };

  const fetchReviews = useCallback(async () => {

    if (!currentProductId) {
      console.log("Current Product ID missing, skipping review fetch.");
      return;
    }

    const token = localStorage.getItem("token");

    setReviewsLoading(true);
    try {
      const config = token ? { headers: { token: token } } : {}; // Send token if available
      const response = await axios.get(`${apiBaseUrl}customer/get-reviews/${currentProductId}`, config);
      if (response.data && response.data.success) {
        setReviews(response.data.data.reviews || []);
      } else {
        console.error("Failed to fetch reviews:", response.data.message);
        setReviews([]);
      }
    } catch (error) {
      console.error("Error fetching reviews:", error);

      setReviews([]);
    } finally {
      setReviewsLoading(false);
    }
  }, [currentProductId]);

  useEffect(() => {
    if (currentProductId) {
      fetchReviews();
    }
  }, [fetchReviews, currentProductId]);

  const fetchLiveStock = async (productId, variant1Id = null, variant2Id = null) => {
    try {
      const params = new URLSearchParams({ productId });
      if (variant1Id) params.append("variant1Id", variant1Id);
      if (variant2Id) params.append("variant2Id", variant2Id);

      const response = await fetch(`${apiBaseUrl}product/get-live-stock?${params.toString()}`);
      const data = await response.json();
      return data.stock || 0;
    } catch (error) {
      console.error("Error checking live stock:", error);
      return 0;
    }
  };


  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const nextSectionRef = useRef(null);
  const buttonsRef = useRef(null);

  useEffect(() => {
    // Create an Intersection Observer to track visibility of next section
    const observer = new IntersectionObserver(
      (entries) => {
        // If next section is visible, hide the buttons
        const entry = entries[0];
        if (entry.isIntersecting) {
          setIsButtonVisible(false);  // Hide buttons
        } else {
          setIsButtonVisible(true);  // Show buttons
        }
      },
      { threshold: 0.5 }  // When 50% of the next section is visible, trigger the callback
    );

    if (nextSectionRef.current) {
      observer.observe(nextSectionRef.current);
    }

    // Cleanup observer on unmount
    return () => {
      if (nextSectionRef.current) {
        observer.unobserve(nextSectionRef.current);
      }
    };
  }, []);

  const fallbackImage = "https://via.placeholder.com/300x300?text=No+Image";

  const saveToRecentlyViewed = (product) => {
    console.log("Saving product to recently viewed:", product);
    console.log("product.id:", product?.id);
    // Removed _id check
    if (!product?.id) {
      console.warn("Product missing id, skipping save.");
      return;
    }

    const existing = JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];

    const updated = existing.filter((p) => p.id !== product.id);
    updated.unshift({
      id: product.id,
      title: product.title,
      image: product.images?.[0] || "https://via.placeholder.com/300x300?text=No+Image",
      images: product.images || [],
      price: product.price,
      mrp: product.mrp,
      skuId: product.skuId,
      productName: product.slug || product.productName,
    });

    console.log("Storing in localStorage:", updated.slice(0, 10));
    localStorage.setItem("recentlyViewedProducts", JSON.stringify(updated.slice(0, 10)));
  };



  // For Dynamic Review in Modal
  const [reviewPopUp,setReviewPopUp] = useState(false);

  const StarRating = ({ rating }) => {
  return (
    <div className="star-box">
      {[...Array(5)].map((_, index) =>
        index < rating ? <FaStar key={index} /> : <FaRegStar key={index} />
      )}
    </div>
  );
};

const ratingCounts = [1, 2, 3, 4, 5].reduce((acc, rating) => {
  acc[rating] = reviews.filter(review => review.rating === rating).length;
  return acc;
}, {});
const totalReviews = reviews.length;

const getWidthPercentage = (count) => {
  return totalReviews === 0 ? 0 : (count / totalReviews) * 100;
};

const averageRating = reviews.length ? (reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1) : 0;

  return (
    <CommonLayout>


      <React.Fragment>
        {loading && productDetails && productDetails[0] ?
          <div>
            <Loader /></div> : null}

        <div className="product-detail-page  ProductItemContainer p-0 w-100 m-0">
          <div>
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="ProductItemDetails">
                  {(productTag && <div className="ItemStatus">
                    <span>{productTag}</span>
                  </div>)}
                  {/* <div className="zoom-image">
            <img src={ZoomImg} alt="zoom image" />
          </div> */}
                  <Swiper
                    key={productDetails?.id || "default-key"}
                    modules={[Pagination]}
                    pagination={{ clickable: true }}
                    spaceBetween={50}
                    slidesPerView={1}
                    navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev",}}
                  >
                    {getFilteredImages().map((item, index) => (
                      <SwiperSlide key={index}>
                        <figure>
                          <ImgOrVideo
                            url={item}
                            uid={uid}
                            type={1}
                            productName={constItemDetails?.title}
                          /></figure>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  
                  <div className="p_viewAll">
                    {/* <FavoriteIcon fontSize="large" className={"favIcon"} /> */}
                    <ShareOutlinedIcon fontSize="large"
                      className="shareIcon"
                      onClick={handleShare}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <div className="product-info-box">
                  <div className="product-des">

                    <h5 className="p-0 constItemTitle">{constItemDetails?.title}</h5>
                    <div className="star-icons">
                      <ul>
                        <li><StarRating rating={Math.round(averageRating)} /></li>
                      </ul>
                      <p>({reviews?.length})</p>
                    </div>
                    <div className=" price constItemPrice">
                      <>
                        <span>
                          &#8377;{" "}
                          {(
                            isVarient
                              ? !selectedVariantValues?.price ||
                                selectedVariantValues?.price === 0
                                ? selectedVariantValues?.mrp
                                : selectedVariantValues?.price
                              : productDetails?.price === 0
                                ? productDetails?.mrp
                                : productDetails?.price
                          )?.toLocaleString("en-IN")}
                        </span>

                        {isVarient &&
                          // selectedVariantValues?.price &&
                          selectedVariantValues?.price !== 0 && (
                            <strike className="main-price">
                              &#8377; {selectedVariantValues?.mrp?.toLocaleString("en-IN")}
                            </strike>
                          )}

                        {!isVarient &&
                          productDetails?.price !== 0 ? (
                          <strike className="main-price">
                            &#8377; {productDetails?.mrp?.toLocaleString("en-IN")}
                          </strike>
                        ) : null}
                      </>

                    </div>
                    <div className="watching-person-text">
                      <RandomNumber mrp={productDetails?.mrp}/>
                    </div>
                  </div>



                  {/* <div className="productpara">
                    <p>
                      This included.{" "}
                      <span className="underline-text">Shipping calculated</span> at
                      checkout
                    </p>
                  </div> */}

                  {/* <div className="size-container">
        <span className="size-text">Product size</span>
        <a href="#" className="size-chart">
          Size Chart
        </a>
      </div> */}


{productDetails?.additionalInfo?.productVariants.length>0?
                  <div className="product-varient-info" >
                    <VariantList
                      productVariants={productDetails?.additionalInfo?.productVariants}
                      onVariantSelect={onVariantSelect}
                    />
                  </div>
                  :null}

                  {/* DISCOUNT COUPANS */}

                  <div className={`cart-container ${isButtonVisible?'showbtns':'hidebtns'}`}>
                    {isInCart ? (
                      <>
                        {/* Increment/Decrement Buttons */}
                        <div className="counter">
                          <button disabled={count === 1} onClick={decrementHandler}>
                            <CiCircleMinus />
                          </button>
                          <div className="counting">{count}</div>
                          <button
                            onClick={() => {
                              if (isIncrementDisabled()) {
                                if (!toast.isActive(TOAST_ID)) {
                                  toast.warn("No more inventory", { toastId: TOAST_ID, position: "top-center", autoClose: 2000 });
                                  // return;
                                } else {
                                  toast.update(TOAST_ID, {
                                    render: "No more inventory",
                                    autoClose: 2000,
                                  });
                                }
                                return;
                              }
                              incrementHandler();
                            }}
                          >
                            <CiCirclePlus />
                          </button>
                        </div>

                        {/* Go to Cart or Out of Stock */}
                        <button className="add_to_cart_btn" onClick={handlegoToCart}>
                          Go to Cart
                        </button>
                      </>
                    ) : (
                      // When not in cart
                      <>
                        {/* Check if the product is out of stock */}
                        {isOutOfStock() ? (
                          <button className="out-of-stock" disabled>
                            Out Of Stock
                          </button>
                        ) : (


                          <>
                          <button
                              className="button common-drawer-btn" 
                              onClick={buyItNow}
                            >
                              Buy now
                            </button>
                            <button className="button theme-btn-outline" disabled={adding} onClick={handleAddToCart}> Add to Cart</button>
                          </>
                        )}
                      </>
                    )}
                  </div>


                  {/* DELIVERY AND ALL */}
                  <Delivery />

                  {/* DESCRIPTION */}
                  <Description productDescription={productDetails?.description} />

                  {/* REVIEWS */}
                  { <ReviewsAccordion
                    reviews={reviews}
                    loading={reviewsLoading}
                    onRateProductClick={handleOpenReviewModal}
                    hasPurchased={hasPurchasedProduct}
                  /> }
                </div>
              </div>
            </div>
          </div>
          {reviews?.length>0?
          <div onClick={()=> setReviewPopUp(true)} className={`review-floating-btn ${isButtonVisible?'showbtns':'hidebtns'}`}>
            <div className="flex">
              <div className="iconBox"><FaStar/></div>
              <div className="text"><p>Reviews ({reviews?.length})</p></div>
            </div>
          </div>
          :''}
          </div>
        </div>

        <div  ref={nextSectionRef} className="related-product-sec">
          <div className="container">
            <FourGrid handleOpenDrawer={handleOpenDrawer} />
            </div>
            </div>

            {/*SIZE CHART*/}
            {/* {productDetails?.sizeChart && productDetails.sizeChart.length > 0 && (
                  <div className="size-chart">
                              <p>Check Size</p>
                              <button data-bs-toggle="modal" data-bs-target="#Sizechart">
                                Size chart
                              </button>
                    </div>
      )} */}

            {/* <div className="reviews-container">
        <h3 className="reviews-title">Customer Reviews</h3>
        <div className="reviews-content">
          <span className="star">⭐</span>
          <h2 className="rating">4.8</h2>
          <p className="out-of">out of 5</p>
        </div>
        <p className="ratings-count">208 Ratings</p>
        <img src={GoogleLogo} alt="Google" className="google-logo" />
      </div> */}

            <div className="categories-sec">
              <div className="container">
                <div className="categories-container">
                  <h2 className="categories-title">Browse Other Categories</h2>

                  {categories?.length > 0 ? (
                    <div className="categories-grid">
                      {categories.map((category) => (
                        <div
                          key={category._id}
                          className="category-item"
                          onClick={() => handleCategoryClick(category.title)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="category-image">
                            <img src={category.categoryImage} alt={category.title} />
                          </div>
                          <p className="category-name">{category.title}</p>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>No categories available. Please check back later.</p>
                  )}
                </div>
              </div>
            </div>


            {/* <div className="product-footer">
        @ 2024 by Hello. All rights reserved.
      </div> */}
            <Footer />

            <CommonModal
              show={show}
              onHide={handleClose}
              handleClose={handleClose}
              title="Return & Replacement Policy"
              content={returnpolicy}
            />
            <CommonDrawer
              isOpen={isDrawerOpen}
              onClose={handleCloseDrawer}
              product={selectedProduct}
            />

            {currentProductId && (
              <ReviewModal
                isOpen={isReviewModalOpen}
                onClose={handleCloseReviewModal}
                productId={currentProductId}
                onSubmitSuccess={handleReviewSubmitSuccess}
              />
            )}
            <div className={`reviewModal popup ${reviewPopUp ? 'show':''}`}>
              <div className="overlayBox"  onClick={()=> setReviewPopUp(false)} ></div>
              <div className="reviewModal-box">
                <div className="header-box">
                  <h3 className="h3">Reviews</h3>
                  <div className="btn-close" onClick={()=> setReviewPopUp(false)}></div>
                </div>
                <div className="body-box">
                  <div className="star-rating-box">
                    <div className="rate-no-box"><h5 className="h5">{averageRating}</h5><span>{reviews?.length} ratings</span></div> 
                    <div className="start-line-box">
                      <div className="star-list">
                        <ul>
                          <li><FaStar /><FaStar /><FaStar /><FaStar /><FaStar /></li>
                          <li><FaStar /><FaStar /><FaStar /><FaStar /></li>
                          <li><FaStar /><FaStar /><FaStar /></li>
                          <li><FaStar /><FaStar /></li>
                          <li><FaStar /></li>
                        </ul>
                      </div>
                      <div className="line-box">
                        <ul>
                          {[5, 4, 3, 2, 1].map((star) => (
      <li key={star}>
        <ins style={{ width: getWidthPercentage(ratingCounts[star]) + '%' }}></ins>
        <span>{ratingCounts[star]}</span>
      </li>
    ))}
                        </ul>
                      </div>
                    </div>
                    </div>
                    <h2 className="title">{reviews?.length} reviews</h2>
                    <div className="reviews-list">
                      {reviews?.length>0 ? 
                      reviews?.map((v,i)=>{
                        const formattedDate = new Date(v.createdAt).toLocaleDateString("en-US", {year: "numeric",month: "long",day: "numeric",});
                        return(
                          <div className="box" key={i}>
                            <div className="headbox">
                              <h6 className="h6">{v?.title}</h6>
                              <div className="rate">
                                <StarRating rating={v.rating} />
                                <div className="date">{formattedDate}</div>
                              </div>
                              <div className="text">
                                <p>{v?.description}</p>
                              </div>
                              <div className="image-box">
                                <figure></figure>
                              </div>
                            </div>
                          </div>
                        )
                      })
                      :''}
                    </div>
                  </div>
              </div>
            </div>
      </React.Fragment>
    </CommonLayout>
  );
}


export default ProductDetails;
